import { fetchWrapper } from '_helpers';

const baseUrl = `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_CONTEXT_PATH}/sub-locations`;

export const subLocationService = {
  search,
  getById,
  create,
  update,
  delete: _delete,
  addBins,
  removeBin,
  removeBins,
};

function search(params) {
  return fetchWrapper.get(`${baseUrl}${params}`);
}

function getById(id) {
  return fetchWrapper.get(`${baseUrl}/${id}`);
}

function create(params) {
  return fetchWrapper.post(baseUrl, params);
}

function update(id, params) {
  return fetchWrapper.put(`${baseUrl}/${id}`, params);
}

function _delete(id) {
  return fetchWrapper.delete(`${baseUrl}/${id}`);
}

function addBins(id, params) {
  return fetchWrapper.put(`${baseUrl}/${id}/bins`, params);
}

function removeBin(id, binId) {
  return fetchWrapper.delete(`${baseUrl}/${id}/bins/${binId}`);
}

function removeBins(id, binIds) {
  return fetchWrapper.delete(`${baseUrl}/${id}/bins?ids=${binIds}`);
}
